
export enum AuthorityLevel {
    Compulsory = "Compulsory",
    Optional = "Optional",
    CanDisables = "CanDisable"
}